const module = { name: 'movie/shared/historyStates', exports: {} }; const exports = module.exports;



import { Fandango_dateUtil as Fandango_dateUtil_dateFromQuery } from 'require-global';

const { dateFromQuery } = Fandango_dateUtil_dateFromQuery;


import { fd_location as fd_location_getLocation } from 'require-global';

const { getLocation } = fd_location_getLocation;


import { Fandango_queryUtil as Fandango_queryUtil_getParam_removeParam_setParam } from 'require-core';

const { getParam, removeParam, setParam } = Fandango_queryUtil_getParam_removeParam_setParam;


import { global_consts as global_consts_QueryParams } from 'require-core';

const { QueryParams } = global_consts_QueryParams;


import { Fandango_debugLog as debugLog } from 'require-core';



import { default as tdpLocationHelper } from 'swug-fdRequire-call:theater/shared/tdpLocationHelper';



const HistoryEventTypes = Object.freeze({
    CALENDAR: 'calendar',
    FORMAT_FILTER: 'formatFilter',
    LOCATION: 'location',
    REMOVE_CHAIN_FILTER: 'removeChain',
    VIEW_TOGGLE: 'viewingToggle',
})


let onNotifyChange


let priorState
function onPopState(event) {
    const newState = event.state && event.state.caller;
    priorState = priorState || newState;
    debugLog.info(module.name, 'onPopState', `(prior: ${priorState}, new: ${newState})`);
    switch (priorState) {
        case HistoryEventTypes.FORMAT_FILTER: {
            const filter = getParam(QueryParams.FORMAT);
            onNotifyChange(HistoryEventTypes.FORMAT_FILTER, { filter });
            break;
        }
        case HistoryEventTypes.CALENDAR: {
            const date = dateFromQuery('d');
            const location = getLocation();
            onNotifyChange(HistoryEventTypes.CALENDAR, { date, location });
            break;
        }
    }
    priorState = newState;
}
function push(type, data) {
    debugLog.info(module.name, `push "${type}"`, data);
    let param;
    switch (type) {
        case HistoryEventTypes.VIEW_TOGGLE:
            param = setParam(QueryParams.VIEWING, data);
            break;
        case HistoryEventTypes.CALENDAR:
            param = setParam(QueryParams.DATE, data);
            break;
        case HistoryEventTypes.FORMAT_FILTER:
            param = setParam(QueryParams.FORMAT, data);
            break;
        case HistoryEventTypes.LOCATION: {
            const pathname = tdpLocationHelper.getShowtimesURL();
            history.pushState({}, null, pathname);
            break;
        }
        case HistoryEventTypes.REMOVE_CHAIN_FILTER: {
            const queryParams = removeParam(QueryParams.CHAIN_ID);
            history.pushState({}, null, queryParams ? `?${queryParams}` : window.location.pathname);
            break;
        }
    }
    priorState = type;
    history.replaceState({ caller: type }, null, param ? `?${param}` : window.location.pathname);
}
function attach(cb) {
    if (typeof cb !== 'function') {
        return;
    }
    onNotifyChange = cb;
    window.onpopstate = onPopState;
}
module.exports = {
    HistoryEventTypes,
    push,
    attach,
};
export default module.exports;